import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { AppFrame, StatusBanner } from '../components/ui';
import { deriveFirstWeekJourney } from '../domain/firstWeekJourney';
import { deriveWeeklyExpedition } from '../domain/weeklyExpedition';
import { WORLD_SPACES, worldSpace } from '../domain/worldSpaces';
import { useAppStore } from '../store/AppStore';
import { WorldReactionStrip } from '../components/worldReactions';

export function ChildWorldHubScreen() {
  const { state } = useAppStore();
  const nickname = state?.child.nickname ?? '탐험가';
  const hub = worldSpace('world-hub');
  const destinations = WORLD_SPACES.filter((space) => space.id !== 'world-hub');
  const firstWeek = state ? deriveFirstWeekJourney(state) : null;
  const weekly = state ? deriveWeeklyExpedition(state) : null;
  const useWeekly = Boolean(firstWeek?.complete);
  const recommendedSpaceId = useWeekly ? weekly?.nextFocus.spaceId : firstWeek?.currentStage.spaceId;

  return <AppFrame title="MRM 스노우 월드" backTo="/child/home" navigation="child" screenClass="world-hub-screen world-hub-2-2 world-hub-2-3 world-hub-2-4 world-hub-2-5 world-hub-2-7">
    <StatusBanner />
    <section className="world-hub-hero" style={{ '--world-scene': `url(${hub.asset})`, '--world-scene-mobile': `url(${hub.mobileAsset})` } as CSSProperties}>
      <div className="world-hub-hero-overlay" />
      <div className="world-hub-copy">
        <p>MRM WORLD MAP · RELEASE 2.7</p>
        <h1>{nickname}아,<br />오늘은 어디로 갈까?</h1>
        <span>공간마다 배우는 힘과 받는 보상이 달라요. 지금 필요한 장소를 직접 골라보세요.</span>
        <div className="world-hub-progress"><strong>{destinations.length}</strong><small>개의 탐험 공간</small><i /><strong>{useWeekly ? `${weekly?.completedCount ?? 0}/5` : `${firstWeek?.completedCount ?? 0}/7`}</strong><small>{useWeekly ? '이번 주 성장' : '첫 주 성장'}</small></div>
      </div>
      <div className="snows-world-guide">
        <div><small>스노스의 오늘 추천</small><strong>{useWeekly ? `${weekly?.nextFocus.shortTitle ?? '베이스캠프'}을 채우면 이번 주 눈꽃이 더 선명해져요!` : `${firstWeek?.currentStage.shortTitle ?? '베이스캠프'}부터 시작하면 좋아요!`}</strong></div>
        <span className="snows-pod"><img src="/assets/characters/snows/snows_wave_v1.png" alt="MRM 스노우 월드를 안내하는 스노스" /></span>
      </div>
    </section>

    {state && <WorldReactionStrip state={state} compact />}

    <section className="world-space-grid" aria-label="MRM 탐험 공간">
      {destinations.map((space) => { const firstStage = firstWeek?.stages.find((stage) => stage.spaceId === space.id); const weeklyPillar = weekly?.pillars.find((pillar) => pillar.spaceId === space.id); const recommended = recommendedSpaceId === space.id; const completed = useWeekly ? weeklyPillar?.completed : firstStage?.completed; const route = recommended ? (useWeekly ? weeklyPillar?.route : firstStage?.route) : space.route; return <Link className={`world-space-card space-${space.id}${recommended ? ' recommended' : ''}${completed ? ' completed' : ''}`} key={space.id} to={route ?? space.route} style={{ '--space-scene': `url(${space.asset})`, '--space-scene-mobile': `url(${space.mobileAsset})` } as CSSProperties}>
        <div className="world-space-card-bg" />
        {recommended && <em className="world-space-recommend">오늘 추천</em>}
        <span className="world-space-order"><img src={space.icon} alt="" /><b>{completed ? '✓' : String(space.order).padStart(2, '0')}</b></span>
        <div className="world-space-card-copy">
          <small>{space.eyebrow} · {space.emotion}</small>
          <h2>{space.shortTitle}</h2>
          <p>{recommended ? (useWeekly ? weeklyPillar?.copy : firstStage?.copy) : space.copy}</p>
          <b>{recommended ? (useWeekly ? weeklyPillar?.actionLabel : firstStage?.actionLabel) : completed ? '완료한 공간 다시 보기' : space.actionLabel}<i>›</i></b>
        </div>
      </Link>; })}
    </section>

    <section className="world-hub-help">
      <img src="/assets/characters/sage/sage_binocular_v1.png" alt="길을 함께 살펴보는 설옹" />
      <div><small>설옹의 지도 읽기</small><h2>모든 공간을 한꺼번에 갈 필요는 없어요</h2><p>오늘 할 일 하나를 끝내면 다음 장소가 더 선명해져요. 빠른 길보다 나에게 맞는 길을 선택하세요.</p></div>
      <div className="world-hub-help-actions"><Link to="/child/first-week">첫 7일 눈길 보기</Link><Link to="/child/weekly-expedition">주간 베이스캠프 보기</Link><Link to="/child/world-journey">세계관 8단계 보기</Link><Link to="/child/passport">금융 패스포트</Link></div>
    </section>
  </AppFrame>;
}
